import { useTranslate } from 'react-t7e';
import { H1Smaller } from 'src/components/common/typography/Header';
import { Markdown } from 'vendor/mods/markdown/components/Markdown';
import React, { useContext } from 'react';
import styled, { keyframes } from 'styled-components';
import { Button } from 'src/components/common/Button';
import { media } from 'src/styles/designs';
import { dirRTL } from 'src/styles/theme';
import { ShowcaseListRenderComponentProps } from 'src/modules/materials/models/showcase';
import { ShowcaseContext } from 'src/modules/materials/providers/ShowcaseContext';

export const GenericSectionHeader = ({
  section,
}: ShowcaseListRenderComponentProps) => {
  const { _, _n } = useTranslate();
  const { itemsToQuery } = useContext(ShowcaseContext);

  return (
    <H1Smaller as="h2">
      <Markdown>{_(section.name)}</Markdown>
      {section.count !== undefined ? (
        <>
          {' '}
          <Markdown>
            {itemsToQuery.includes('materials')
              ? _n(
                  '({count} Item)',
                  '({count} Items)',
                  section.count,
                  undefined,
                  {
                    count: section.count,
                  },
                )
              : _n(
                  '({count} Video)',
                  '({count} Videos)',
                  section.count,
                  undefined,
                  {
                    count: section.count,
                  },
                )}
          </Markdown>
        </>
      ) : null}
    </H1Smaller>
  );
};

const disableLater = keyframes`
  from, 99% {
    pointer-events: all;
  }
  to {
    pointer-events: none;
  }
`;

export const NavigationButton = styled(Button)<{
  $direction: 'left' | 'right';
}>`
  && {
    position: absolute;
    z-index: 3;
    margin: 15.25px;
    top: calc(43.55px - 15.25px + 1rpx);
    background: rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(8px);
    border-radius: 50%;

    ${({ $direction }) => $direction}: 0;
    ${dirRTL} {
      ${({ $direction }) => $direction}: auto;
      ${({ $direction }) => ($direction === 'left' ? 'right' : 'left')}: 0;
    }

    .swiper:not(.swiper-initialized) {
      opacity: 0 !important;
    }

    &[disabled],
    &.hidden {
      opacity: 0 !important;
      animation: ${disableLater} 1s linear forwards;
    }

    &:not(:focus) .btn__content:before {
      border-color: transparent !important;
    }

    .btn__content svg {
      filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.3));
    }

    ${media.w.lessThan.desktop} {
      display: none;
    }
  }
`;
